import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';

import { DailyReport } from '../../../types/Chatbot';

@Component({
  selector: 'app-chat-daily-report-card',
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule, MarkdownModule],
  templateUrl: './chat-daily-report-card.component.html',
  styleUrl: './chat-daily-report-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatDailyReportCardComponent {
  public readonly report = input.required<DailyReport>();
  public readonly dismissed = output<void>();

  public openReport(): void {
    const url = this.report().url;
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
